<template>
  <transition name="header-profile-transition">
    <div class="header_profile_menu" v-show="show">
      <div class="header_profile_menu_top">{{ $t("personal_cabinet") }}</div>
      <ul>
        <li>
          <router-link
            :to="{ name: 'counterparty.index' }"
            :class="{ active: routeLayout === 'counterparty' }"
            @click="$emit('close')"
          >
            <BaseIcon
              icon="contragent-icon"
              :active="routeLayout === 'counterparty'"
            />
            <span>{{ $t("counterparties") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :class="{ active: currentRoute === 'contract.index' }"
            :to="{ name: 'contract.index' }"
          >
            <BaseIcon
              icon="contract-icon"
              :active="currentRoute === 'contract.index'"
            />
            <span>{{ $t("contracts") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'mcp.access.index' }"
            :class="{ active: routeLayout === 'mcp' }"
            @click="$emit('close')"
          >
            <BaseIcon
              icon="integration-icon"
              :active="routeLayout === 'mcp'"
            />
            <span>{{ $t("mcp_access.menu") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'referral.program.index' }"
            :class="{ active: routeLayout === 'referral' }"
            @click="$emit('close')"
          >
            <BaseIcon
              icon="referrals-icon"
              :active="routeLayout === 'referral'"
            />
            <span>{{ $t("referral_program") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'profile.info' }"
            :class="{ active: routeLayout === 'profile' }"
            @click="$emit('close')"
          >
            <BaseIcon icon="setting-icon" :active="routeLayout === 'profile'" />
            <span>{{ $t("personal_settings") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'history.user.index' }"
            :class="{ active: routeLayout === 'history' }"
            @click="$emit('close')"
          >
            <BaseIcon icon="history-icon" :active="routeLayout === 'history'" />
            <span>{{ $t("sidebar.history") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'invitation.counterparties' }"
            :class="{ active: routeLayout === 'invitation' }"
            @click="$emit('close')"
          >
            <BaseIcon
              icon="invitation-icon"
              :active="routeLayout === 'invitation'"
            />
            <span>{{ $t("invitations") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :class="{ active: routeLayout === 'price' }"
            :to="{ name: 'price.index' }"
          >
            <BaseIcon
              icon="price-icon"
              :active="routeLayout === 'price'"
            />
            <span>{{ $t("sidebar.price") }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :class="{ active: routeLayout === 'instruction' }"

            :to="{ name: 'instruction.index' }"
          >
            <BaseIcon
              icon="instruction-icon"
              :active="routeLayout === 'instruction'"
            />
            <span>{{ $t("sidebar.instruction") }}</span>
          </router-link>

        </li>

        <li>
          <router-link
            :class="{ active: routeLayout === 'support' }"
            :to="{ name: 'support.index' }"
          >
            <BaseIcon
              icon="support-icon"
              :active="routeLayout === 'support'"
            />
            <span>{{ $t("sidebar.support") }}</span>
          </router-link>
        </li>

        <li>
          <a
            :href="regulationPdfUrl"
            target="_blank"
            rel="noopener noreferrer"
            download
            @click="$emit('close')"
          >
            <BaseIcon icon="file-icon" />
            <span>{{ $t("sidebar.regulation") }}</span>
          </a>
        </li>

        <li>
          <a href="javascript:void(0);" @click="logout()">
            <BaseIcon icon="exit-icon" />
            <span>{{ $t("exit") }}</span>
          </a>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { logout } from "~/api/auth";
import { REGULATION_PDF_URL } from "~/constants/legal";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      regulationPdfUrl: REGULATION_PDF_URL
    };
  },
  methods: {
    logout: async function() {
      let result = await logout();

      if (result) {
        const fullPath = this.$router.resolve({
          name: "auth.login",
          query: { loggedOut: "true" }
        }).href;

        window.location.href = fullPath;
      }
    }
  },
  computed: {
    routeLayout: function() {
      return this.$route.name.split(".")[0];
    },
    currentRoute() {
      return this.$route.name;
    }
  }
};
</script>

<style scoped lang="scss">
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
